import { useEffect, useState } from 'react';

// Tiny responsive primitive: the current layout viewport width, updated on
// resize. The My Trips pages live in a fixed-width column (maxWidth 560, 16px
// padding), so this fully determines the content width — enough to drive the
// handful of responsive tweaks (hide an action on mobile, trim how many pills
// fit) without per-component ResizeObservers.
//
// Uses document.documentElement.clientWidth, NOT window.innerWidth: the former
// is the real CSS layout width (and matches device emulation), while innerWidth
// includes the scrollbar and over-reports under emulated mobile viewports.
function readWidth(): number {
  if (typeof document !== 'undefined' && document.documentElement) {
    return document.documentElement.clientWidth;
  }
  return typeof window !== 'undefined' ? window.innerWidth : 1024;
}

export function useViewportWidth(): number {
  const [width, setWidth] = useState<number>(readWidth);

  useEffect(() => {
    const onResize = () => setWidth(readWidth());
    window.addEventListener('resize', onResize);
    onResize(); // sync once in case it changed before mount
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return width;
}

export default useViewportWidth;
